<template>
	<div>
		<div id="private-area-page" v-if="showRootPage">
			<section class="bg-green-light">
				<div class="container h-100">
					<div class="row">
						<div class="col 12 text-center mb-4" style="margin-top:160px;">
							<h1> Ciao, {{name}}!</h1>
							<p class="font-grandstander fs-1-25">
								IL TUO NOME È ASSOCIATO ALLA SCUOLA “{{school}}”
							</p>
						</div>
					</div>
				</div>
			</section>

			<section id="welcome">
				<div class="container">
					<div class="row">
						<div class="col-12 text-center mt-5">
							<h2 class="fs-2-5">Siamo felici di vederti qui,<br>ti diamo il benvenuto nella tua area riservata</h2>
						</div>
					</div>
				</div>
			</section>

			<section id="istruction">
				<div class="container">
					<div class="row justify-content-center mt-3 overflowy-hidden" :class="{'animeted-element fade-bottom': !isFirst}">
						<div class="col-sm-6 col-lg-3">
							<div class="w-100 text-center">
								<img class="img-fluid" :src="themeDir + '/img/arearis-1.png'" alt="icon">
								<p class="bold fs-1-2 mt-3">PORTA IN CLASSE IL PROGETTO CON I LABORATORI E I MATERIALI DIDATTICI</p>
							</div>
						</div>

						<div class="col-sm-6 col-lg-3">
							<div class="w-100 text-center">
								<img class="img-fluid" :src="themeDir + '/img/arearis-2.png'" alt="icon">
								<p class="bold fs-1-2 mt-3">RISPONDI AL QUESTIONARIO</p>
							</div>
						</div>

						<div class="col-sm-6 col-lg-3">
							<div class="w-100 text-center">
								<img class="img-fluid" :src="themeDir + '/img/arearis-3.png'" alt="icon">
								<p class="bold fs-1-2 mt-3">CARICA ALMENO UN MOTTO DI CLASSE CHE RIASSUME IL VOSTRO PERCORSO</p>
							</div>
						</div>

						<div class="col-sm-6 col-lg-3">
							<div class="w-100 text-center">
								<img class="img-fluid" :src="themeDir + '/img/arearis-4.png'" alt="icon">
								<p class="bold fs-1-2 mt-3">CARICA LA FOTO DI UN DISEGNO REALIZZATO IN CLASSE SU UNO DEI TEMI DEI LABORATORI DIDATTICI</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="lab" class="pb-3">
				<div class="container">
					<div class="row">
						<div class="col-12 text-center mt-4">
							<h2 class="fs-2-5">I laboratori da portare in classe</h2>
							<p>
								<strong>Scopri i laboratori</strong> del progetto, <strong>scarica</strong> i <strong>materiali</strong> e guarda i video in classe per giocare
								con i tuoi piccoli studenti e approfondire il tema della sostenibilità, dell’educazione alimentare e degli Obiettivi dell’Agenda 2030.<br>
								Ricorda di verificare che l’età segnalata in ogni laboratorio sia quella della tua classe.
							</p>
						</div>
					</div>
				</div>

				<div class="container mb-5">
					<div class="row">
						<div class="col-12 text-center mt-5">
							<h2 class="fs-2 text-black">AGENDA 2030</h2>
						</div>
					</div>

					<div class="row justify-content-center">
						<div class="col-xl-10 col-xxl-8">
							<div class="row justify-content-center">

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-green2 text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">4-7 ANNI</span>
										</p>

										<h2 class="text-white">PICCOLE AZIONI PER GRANDI OBIETTIVI</h2>
										<p class="bold">
											Dietro ogni azione virtuosa c’è un obiettivo condiviso da tutti i Paesi della Terra e dall’Agenda 2030!
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'piccole-azioni-per-grandi-obiettivi/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-green2 text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">8-11 ANNI</span>
										</p>

										<h2 class="text-white">SCEGLIAMO BENE!</h2>
										<p class="bold">
											Consumo e produzione sostenibili sono il tema dell’Obiettivo 12, che coinvolge persone e aziende.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'scegliamo-bene/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-12 text-center mt-5">
									<h2 class="fs-2 text-black">SOSTENIBILITÀ</h2>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-primary text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">8-11 ANNI</span>
										</p>

										<h2 class="text-white">PIÙ INSALATA PER TUTTI</h2>
										<p class="bold">
											Produrre insalate in modo sostenibile si può: agricoltura moderna, cooperative agricole e non solo.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'piu-insalata-per-tutti/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-primary text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">8-11 ANNI</span>
										</p>

										<h2 class="text-white">PLASTICA: CONOSCERLA PER USARLA AL MEGLIO</h2>
										<p class="bold">
											Di quale materiale è fatta la confezione dei prodotti che consumiamo?
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'plastica/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-primary text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">8-11 ANNI</span>
										</p>

										<h2 class="text-white">COOPERARE È MEGLIO CHE LITIGARE</h2>
										<p class="bold">
											Cooperare permette di lavorare al meglio e di valorizzare le competenze di ognuno.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'cooperare/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-primary text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">4-7 ANNI</span>
										</p>

										<h2 class="text-white">ORTO IN CLASSE</h2>
										<p class="bold">
											Come imparare a prendersi cura della natura anche in classe: partiamo dalle piccole cose.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'orto-in-classe/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div class="container mb-5">
					<div class="row">
						<div class="col-12 text-center mt-3">
							<h2 class="fs-2 text-black">EDUCAZIONE ALIMENTARE</h2>
						</div>
					</div>

					<div class="row justify-content-center">
						<div class="col-xl-10 col-xxl-8">
							<div class="row justify-content-center">

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-yellow text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">8-11 ANNI</span>
										</p>

										<h2 class="text-white">LETTURA DELLE ETICHETTE</h2>
										<p class="bold">
											La carta d’identità del cibo che acquistiamo e consumiamo.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'lettura-etichette/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-yellow text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">8-11 ANNI</span>
										</p>

										<h2 class="text-white">ALIMENTAZIONE VARIA</h2>
										<p class="bold">
											Alla scoperta dei principi nutritivi di ogni alimento.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'alimentazione-varia/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

								<div class="col-md-6 mt-4">
									<div class="game-box px-4 px-xl-5 pb-5 pt-4 text-center bg-yellow text-white">
										<p class="text-black font-grandstander">
											<span class="bg-white va-sub px-3 pt-2 pb-1 fs-1-2">4-7 ANNI</span>
										</p>

										<h2 class="text-white">FRUTTA E VERDURA A COLORI</h2>
										<p class="bold">
											I colori degli alimenti ci aiutano a scegliere il meglio per la nostra salute.
										</p>

										<div class="btn-game-box">
											<a :href="siteUrl + 'frutta-e-verdura-a-colori/'" class="btn btn-white rounded-pill px-5 py-1">
												<span class="va-sub">APRI</span>
											</a>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="survey-section" class="bg-green-light pt-5 pb-4">
				<div class="container">

					<div class="row">
						<div class="col-12">
							<div class="row">

								<div class="col-12 text-center mt-3">
									<h2 class="fs-2-5">Partecipa all’iniziativa libera e prova a far aggiudicare alla tua scuola i premi in palio!</h2>
								</div>

								<div class="col-12 text-center mt-4 mb-3">
									<p class="font-grandstander text-yellow fs-1-6 mb-0">
										STEP 1 - OBBLIGATORIO
									</p>
									<h3 class="fs-2-4 text-black">RISPONDI A 7 BREVI DOMANDE SUL PROGETTO</h3>
									<p class="mb-2">
										<strong>Dicci la tua</strong> e <strong>completa il questionario</strong> per partecipare all’iniziativa libera <strong>entro il 14 aprile 2025</strong>.
										Ti invitiamo a compilarlo dopo aver portato in classe <strong>almeno un laboratorio</strong>.<br>
										<strong>Per partecipare all’iniziativa, è necessario procedere prima con lo STEP 1 (questionario) e poi con lo STEP 2 (motto).</strong>
									</p>
									<small class="fs-0-8">Procedura obbligatoria. Per partecipare, è necessario rispondere al questionario solo una volta.</small>
								</div>

							</div>
						</div>
					</div>

					<survey-component
						:done="surveyIsDone"
						@check-survey="checkSurveyIsDone"
					></survey-component>
				</div>
			</section>

			<section id="works-section" class="bg-green-light pb-3" :class="{'disable-section': !pointerEvents}" :style="{opacity: opacitySurvey}">
				<div class="container">

					<div class="row">
						<div class="col-12">
							<div class="row">

								<div class="col-12 text-center mt-4 mb-2">
									<p class="font-grandstander text-yellow fs-1-6 mb-0">
										STEP 2 - OBBLIGATORIO
									</p>
									<h3 class="fs-2-4 text-black">CARICA IL MOTTO DI CLASSE</h3>
									<p class="mb-2">
										Per partecipare all’iniziativa e provare a far vincere la tua scuola dovrai aggiungere <strong>almeno una classe</strong> e caricare <strong>almeno un motto,
										entro il 14 aprile 2025</strong>, che racconti il percorso fatto in classe: cosa avete scoperto? Cosa vi è piaciuto? Per cosa ringraziate la natura?<br>
										Potrai <strong>rivedere e eliminare</strong> i tuoi <strong>motti</strong> fin quando non saranno approvati e visibili in <a :href="siteUrl + 'gallery/'">gallery</a> e potrai aggiungere nuove classi in ogni momento.
									</p>
									<small class="fs-0-8">
										Procedura obbligatoria. Per partecipare, è necessario caricare almeno un motto. Il contenuto dovrà essere approvato dalla segreteria organizzativa.
										Solo dopo, lo troverai nella pagina gallery del progetto.
									</small>
								</div>

							</div>
						</div>
					</div>

				</div>
			</section>

			<section id="photo-section" class="bg-green-light pb-4" :class="{'disable-section': !pointerEvents}" :style="{opacity: opacitySurvey}">
				<div class="container">

					<div class="row">
						<div class="col-12">
							<div class="row">

								<div class="col-12 text-center mt-4 mb-2">
									<p class="font-grandstander text-yellow fs-1-6 mb-0">
										STEP 3 - FACOLTATIVO
									</p>
									<h3 class="fs-2-4 text-black">CARICA LA FOTO DI UN DISEGNO</h3>
									<p class="mb-2">
										Realizzate un <strong>disegno</strong> che racconti uno dei <strong>temi</strong> affrontati grazie ai <strong>laboratori</strong> del progetto e, entro il 14 aprile 2025,
										carica la <strong>foto</strong> del disegno dal pulsante che trovi sotto! Tutti i disegni, saranno valutati dalla <strong>giuria di qualità</strong> e potranno aggiudicarsi un buono in materiale didattico.
										In più, a discrezione di OrtoRomi, i disegni più belli potranno diventare parte integrante della confezione di uno dei nuovi prodotti del brand.<br>
										Conserva il disegno originale e ricorda che il caricare la foto è <strong>facoltativo</strong> e non vincolante alla partecipazione dell’iniziativa libera, diversamente dal questionario e dal motto.
									</p>
									<small class="fs-0-8">
										Procedura facoltativa. Dopo il caricamento, il contenuto dovrà essere approvato dalla segreteria organizzativa. Solo dopo, lo troverai nella pagina <a :href="siteUrl + 'gallery/'">gallery</a> del progetto.
									</small>
								</div>

							</div>
						</div>
					</div>

				</div>
			</section>

			<section id="classes-section" class="bg-green-light pt-1 position-relative" :class="{'disable-section': !pointerEvents}" style="padding-bottom: 7%" :style="{opacity: opacitySurvey}">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<div class="row">

								<div class="col-12 text-center mt-4 mb-2">
									<h3 class="fs-2-5">Carica i tuoi contributi</h3>
								</div>

								<div class="col-12">
									<root-classes-works-component
										:surveyIsDone="surveyIsDone"
										:school-type="schoolType"
										@btn-work-clicked="btnWorkClicked"
									></root-classes-works-component>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div class="grass w-100">
					<img :src="themeDir + 'img/erba.png'" class="img-fluid w-100">
				</div>
			</section>
		</div>

		<div id="class-works-form" v-else>
			<class-work-form
				:school="school"
				:classData="selectedClassData"
				@go-back="onGoBack"
			></class-work-form>
		</div>

		<!-- ** Modal ************************* -->
		<modal name="root-msg-modal"
			height="auto"
			:adaptive=true
			:maxWidth="400"
			id="root-msg-modal"
		>
			<div class="container">
				<div class="row" style="margin-right:-2rem;">
					<div class="col-12 text-right lh-0-9"><i class="fas fa-times hover-default fs-1-8 lh-1" @click.prevent="$modal.hide('root-msg-modal')"></i></div>
				</div>
				<div class="row">
					<div class="col-12 text-center">
						<h3 v-html="msgModal.title"></h3>
					</div>
					<div class="col-12 text-center">
						<p class="fs-1-2 mb-0" v-html="msgModal.msg"></p>
					</div>
				</div>
			</div>
		</modal>

	</div>
</template>

<script>
import axios from 'axios'
import {urlBase, urlHost, themeDir} from '../../variables'
import SurveyComponent from './SurveyComponent.vue'
import RootClassesWorksComponent from '../ClassesWorks/RootClassesWorksComponent.vue'
import ClassWorkForm from '../ClassesWorks/ClassWorkForm.vue'

export default {
	name: 'RootPrivateArea',
	props:['name', 'school', 'survey', 'schoolType'],
	components: {SurveyComponent, RootClassesWorksComponent, ClassWorkForm},

	watch: {
		surveyIsDone: function (val) {
			this.opacitySurvey = val ? '1' : '0.3'
			this.pointerEvents = val ? true : false
		}
	},

	data() {
		return {
			ajaxObj: window.ajax_object,
			themeDir: urlBase + themeDir,
			siteUrl: urlBase + urlHost,
			showRootPage: true,
			isFirst: 0,
			selectedClassData: {},
			surveyIsDone: this.survey,
			msgModal: {
				title: '',
				msg: ''
			},
			opacitySurvey: this.survey ? '1': '0.3',
			pointerEvents: this.survey ? true : false
		}
	},

	methods: {
		checkSurveyIsDone() {
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_check_survey_is_done')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)

			axios.post(url, formData)
				.then((response) => {
					this.surveyIsDone = response.data.survey
				}, (error) => {
					console.log(error);
				});
		},

		btnWorkClicked(classItem) {
			if(this.surveyIsDone) {
				this.selectedClassData = classItem
				this.showRootPage = false
			} else {
				this.msgModal.title = 'Attenzione!'
				this.msgModal.msg = 'Per accedere a questa sezione, bisogna prima compilare il questionario.'
				this.$modal.show('root-msg-modal')
			}
		},

		onGoBack() {
			this.showRootPage = true
			this.isFirst++
			setTimeout(() => {
				window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" })
			}, 400);
		},

	}
}
</script>

<style scoped>
.disable-section {
	pointer-events: none;
}
</style>
